import { render } from "./index.vue?vue&type=template&id=d48c2f0e&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=d48c2f0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48c2f0e"]])

export default __exports__